import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLanguage } from "../i18n";

const KEY = "farlight_cookie_consent";

export const getCookieConsent = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};

export const CookieBanner = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => { if (!getCookieConsent()) setVisible(true); }, []);

  const decide = (analytics) => {
    const consent = { necessary: true, analytics, marketing: analytics, at: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(consent));
    window.farlightConsent = consent;
    window.dispatchEvent(new CustomEvent("farlight:consent", { detail: consent }));
    setVisible(false);
  };

  if (!visible) return null;
  const c = t.cookies;
  return (
    <div data-testid="cookie-banner" role="dialog" aria-live="polite" className="fixed inset-x-4 bottom-4 sm:left-6 sm:right-auto sm:max-w-md z-[60] bg-espresso text-cream border border-cream/10 rounded-sm shadow-[0_24px_60px_rgba(26,24,23,0.45)] p-5">
      <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-amberl"><Cookie className="w-4 h-4" strokeWidth={1.5} />{c.title}</p>
      <p className="mt-2 text-sm leading-relaxed text-cream/80">{c.text} <Link to="/legal/cookie" className="underline text-amberl">{c.policy}</Link></p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button data-testid="cookie-accept" onClick={() => decide(true)} className="bg-amberl text-espresso hover:bg-cream rounded-sm px-5 h-10 text-xs font-semibold uppercase tracking-[0.15em] transition-colors">{c.accept}</button>
        <button data-testid="cookie-reject" onClick={() => decide(false)} className="border border-cream/30 text-cream hover:bg-cream hover:text-espresso rounded-sm px-5 h-10 text-xs font-semibold uppercase tracking-[0.15em] transition-colors">{c.reject}</button>
      </div>
    </div>
  );
};
